
import { defineComponent, PropType } from 'vue';
import { QuestionAnswerState } from '@/vuex/AnswerStore';
import { GqlAllMyReports } from '@/gql/AllMyReports';
import InspectDecimal from '@/components/Forms/QuestionType/Decimal.vue';

export default defineComponent({
  props: {
    value: { type: Object },
    qa: { type: Object as PropType<QuestionAnswerState> },
    report: { type: Object as PropType<GqlAllMyReports> },
  },
  components: {
    InspectDecimal,
  },
  methods: {
    updateValue(e) {
      this.$emit('updateValue', [e[0], e[1]]);
    },
  },
});
